<template>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="row">
        <div class="col-12">
            <div class="form-row">

            </div>
            <div class="form-row">
                <div class="form-group col-md-8">
                    <label>Escuela profesional</label>
                    <v-select
                            :options="carreras_profesionales"
                            label="carrera"
                            :reduce="carrera=>carrera.codigo"
                            v-model="codigo_carrera"
                    />

                </div>
                <div class="form-group col-md-4">
                    <label>Ref</label>
                    <input class="form-control"  v-model="numero_referencia" readonly />
                </div>

            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label>DNI</label>
                    <input class="form-control" v-model="documento_identidad_numero"/>
                </div>
                <div class="form-group col-md-6">
                    <label>Codigo estudiante</label>
                    <input class="form-control" v-model="codigo"/>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label>Archivo</label>
                    <b-form-file id="file-default"  v-model="archivos" multiple ></b-form-file>
                </div>

            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <b-progress :value="uploadPercentage" :max="100" show-progress animated></b-progress>
                </div>
            </div>

            <b-row align-h="end">
                <button class="btn btn-info m-1" v-on:click="validar()">OK</button>
                <button class="btn btn-warning m-1" v-on:click="salir">Salir</button>

            </b-row>
        </div>
    </div>
    </b-overlay>

</template>

<script>
    import constantes from "../config/Constantes";

    export default {
        name: "validar-identificacion",
        data(){
            return {
                documento_identidad_numero:null,
                codigo:null,
                carreras_profesionales:constantes.carreras_profesionales_habilitadas,
                codigo_carrera:null,
                isLoading:false,
                uploadPercentage:0,
                archivos:null
            }
        },
        components:{

        },

        props: {
            numero_referencia:String
        },
        methods :{
            uploadComplete(){

            },
            salir(){


            },
            validar(){
                if(this.archivos==null)
                {
                    this.$swal('Cuidado','Seleccione el archivo','warning');
                    return;
                }

                this.isLoading=true;

                let formData = new FormData();
                formData.append('codigo',this.codigo);
                formData.append('documento_identidad_numero',this.documento_identidad_numero);
                formData.append('codigo_carrera',this.codigo_carrera);
                formData.append('numero_referencia',this.numero_referencia);

                this.archivos.forEach((item)=>{
                    formData.append('file[]',item);
                });

                this.axios.post( process.env.VUE_APP_BACKEND+'/estudiantes/validar-identidad-subir-archivo' ,
                    formData,
                    {
                        onUploadProgress: function( progressEvent ){
                            this.uploadPercentage = parseInt(
                                Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                            console.log(this.uploadPercentage);
                        }.bind(this)
                    }
                )
                    .then( (response) =>{
                        if(response.data.success){
                            this.$swal('Ok','Se subio el archivo','success');
                        }

                    })
                    .finally(()=>
                    {
                        this.isLoading=false;
                    })
                    .catch((error) =>{
                        this.$swal('Cuidado',error.response.data.mensaje,'warning');
                        this.isLoading=false;
                        //console.log(error);
                    });

            },

        }
    }
</script>

<style scoped>

</style>